
import "jquery-match-height"
import ga4 from '../lib/ga-helper'
import '../lib/joincapture.js'

$(() => {
  $('[data-open=signUpModal]').each(function(i, el){
    const $joinButton = $(el)
    $joinButton.on('click', function(){
      ga4.trackEvnt('campaign_page_join', {
        'conversion_type': 'Join - show form',
        'link_text': $joinButton.text(),
        'link_url': $joinButton.attr('href')
      })
    })
  })
  const mHeigths = ['.js-top-info-match-height', '.js-join-match-height']
  $.each(mHeigths, function(i, selector) {
    $(selector).matchHeight({property: 'height'})
  })
  class ScrollTo {
    constructor($mainNavLinks){
      this.resizeTimer
      this.getHeaderOffset()
      this.$scrollSections = $('.js-scroll-to-section')
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer)
        this.resizeTimer = setTimeout(() => {
          this.getHeaderOffset()
        }, 500)
      })
      this.$scrollSections.each((id, section) => {
        const $section = $(section)
        $(window).on('scroll', () => {
          let timer
          clearTimeout(timer)
          timer = setTimeout(()=>{
            if (this.isOnScreen($section) && $section.hasClass('in-view') === false) {
              this.$scrollSections.removeClass('in-view')
              $section.addClass('in-view')
              $mainNavLinks.removeClass('active')
              $mainNavLinks.each((i, link) => {
                if ($(link).attr('href').includes($section.attr('id'))) {
                  $(link).addClass('active')
                }
              })
            }
          }, 500)
        })
      })
      $mainNavLinks.on('click', (ev) => {
        const hashValue = ev.target.hash,
        $target = $(hashValue)
        if (hashValue != '') {
          ev.preventDefault()
          this.scrollToTop($target)
        }
      })
    }
    getHeaderOffset() {
      const pageHeader = document.getElementById('js-join-header')
      if (pageHeader) {
        this.headerOffset = pageHeader.getBoundingClientRect().height
      }
    }
    scrollToTop (target) {
      const topOffset = (target[0].getBoundingClientRect().top - document.body.getBoundingClientRect().top) - this.headerOffset
      window.scrollTo({ behavior: 'smooth', top: topOffset})
    }
    isOnScreen($element) {
      const hT = $element.offset().top,
      hH =  $element.outerHeight(),
      wH = $(window).height(),
      dS = $(document).scrollTop(),
      elementTopOffset = (hT+hH-wH) < 0 ? 0 : hT+hH-wH
      return dS > elementTopOffset && dS < (hT+hH) ? true : false
    }
  }
  const $mainNavLinks = $('.js-main-nav > li > a, .js-here-for-you-btn')
  if ($mainNavLinks.length) {
    new ScrollTo($mainNavLinks);
  }
  $('.js-back-to-top').on('click', function(){
    window.scrollTo({ behavior: 'smooth', top: 0})
  })

  $('#mobile-menu a').on('click', ()=>{
    $('.menu-icon.js-main-menu').trigger('click')
  })
})
